import React from 'react';
import colors from 'utils/stylesheet/colors';
import { Menu, MenuItem, withStyles, Fade } from '@material-ui/core';

export const StyledMenu = withStyles({
  paper: {
    backgroundColor: colors.white,
    minWidth: '10rem'
  }
})((props) => (
  <Menu
    anchorEl={props.anchorEl}
    keepMounted
    open={Boolean(props.anchorEl)}
    TransitionComponent={Fade}
    {...props}
  />
));

export const StyledMenuItem = withStyles(() => ({
  root: {
    color: colors.purple,
    padding: '1rem auto',
    '&:hover': {
      backgroundColor: colors.lilac,
      color: colors.purple
    }
  }
}))(MenuItem);
